export const BOSS_FINAL_BASE_DURATION_MS = 12_750;
export const BOSS_FINAL_HIGHLIGHT_LIMIT = 7;
export const BOSS_FINAL_HIGHLIGHT_MS = 2_700;
export const BOSS_FINAL_DURATION_MS = BOSS_FINAL_BASE_DURATION_MS
    + BOSS_FINAL_HIGHLIGHT_LIMIT * BOSS_FINAL_HIGHLIGHT_MS;

export const BOSS_FINAL_PHASES = Object.freeze({
    CLUSTER_HOLD: 'cluster-hold',
    INSIGHT_HIGHLIGHT: 'insight-highlight',
    SCATTER: 'scatter',
    CAR_ASSEMBLY: 'car-assembly',
    CAR_HOLD: 'car-hold'
});

export const BOSS_FINAL_MARKERS = Object.freeze({
    CLUSTER_END: 1_000,
    HIGHLIGHTS_END: 19_900,
    SCATTER_END: 20_900,
    ASSEMBLY_END: BOSS_FINAL_DURATION_MS
});

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

/** Single assembly; the completed car remains visible indefinitely. */
export function getBossFinalFrame (elapsedMs, insightCount = BOSS_FINAL_HIGHLIGHT_LIMIT) {
    const highlightCount = clamp(Number.isFinite(insightCount) ? Math.floor(insightCount) : 0,
        0, BOSS_FINAL_HIGHLIGHT_LIMIT);
    const highlightsMs = highlightCount * BOSS_FINAL_HIGHLIGHT_MS;
    const durationMs = BOSS_FINAL_BASE_DURATION_MS + highlightsMs;
    const elapsed = clamp(Number.isFinite(elapsedMs) ? elapsedMs : 0, 0, durationMs);
    const completed = elapsed >= durationMs;
    const CLUSTER_END = BOSS_FINAL_MARKERS.CLUSTER_END;
    const HIGHLIGHTS_END = CLUSTER_END + highlightsMs;
    const SCATTER_END = HIGHLIGHTS_END + 1_000;
    const ASSEMBLY_END = durationMs;
    let phase;
    let phaseProgress;
    let highlightIndex = -1;
    let highlightProgress = 0;
    let highlightAmount = 0;
    if (completed) {
        phase = BOSS_FINAL_PHASES.CAR_HOLD;
        phaseProgress = 1;
    } else if (elapsed >= SCATTER_END) {
        phase = BOSS_FINAL_PHASES.CAR_ASSEMBLY;
        phaseProgress = (elapsed - SCATTER_END) / (ASSEMBLY_END - SCATTER_END);
    } else if (elapsed >= HIGHLIGHTS_END) {
        phase = BOSS_FINAL_PHASES.SCATTER;
        phaseProgress = (elapsed - HIGHLIGHTS_END) / (SCATTER_END - HIGHLIGHTS_END);
    } else if (elapsed >= CLUSTER_END) {
        phase = BOSS_FINAL_PHASES.INSIGHT_HIGHLIGHT;
        const offset = elapsed - CLUSTER_END;
        const localMs = offset % BOSS_FINAL_HIGHLIGHT_MS;
        highlightIndex = Math.floor(offset / BOSS_FINAL_HIGHLIGHT_MS);
        highlightProgress = localMs / BOSS_FINAL_HIGHLIGHT_MS;
        highlightAmount = clamp(Math.min(localMs / 350, (BOSS_FINAL_HIGHLIGHT_MS - localMs) / 350), 0, 1);
        phaseProgress = offset / highlightsMs;
    } else {
        phase = BOSS_FINAL_PHASES.CLUSTER_HOLD;
        phaseProgress = elapsed / CLUSTER_END;
    }
    return Object.freeze({
        elapsedMs: elapsed,
        durationMs,
        overallProgress: elapsed / durationMs,
        highlightCount,
        highlightIndex,
        highlightProgress,
        highlightAmount,
        cycleIndex: 0,
        cycleElapsedMs: elapsed,
        phase,
        phaseProgress,
        completed
    });
}
